import React from "react";
import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";

const root = document.getElementById("root");
const rootContainer = createRoot(root);
rootContainer.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
